import { FunctionComponent } from 'react';

import { Avatar as RadixAvatar, AvatarProps } from '@radix-ui/themes';

export const Avatar: FunctionComponent<AvatarProps> = (props: AvatarProps) => {
  return <RadixAvatar {...props} />;
};
